"use client";

import { lazy, Suspense } from "react";
import { useSignupModal } from "@/components/popups/SignupModalContext";

const SignupModal = lazy(() =>
  import("@/components/popups/SignupModal").then((module) => ({
    default: module.SignupModal,
  })),
);

/**
 * O formulário, o Zod e os ícones do modal só são baixados quando alguém
 * realmente pede para abrir o cadastro. Na visita comum, esse código não
 * compete com o Hero pelo tempo de CPU e pela rede.
 */
export function LazySignupModal() {
  const { isOpen } = useSignupModal();

  if (!isOpen) return null;

  return (
    <Suspense fallback={null}>
      <SignupModal />
    </Suspense>
  );
}
